/* ================================================== */
/* PLYR
/* ================================================== */

var plyrOptions = {
	controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen'],
	storage: false,
	captions: { active: true },
	vimeo: { controls: false, playsinline: true },
	youtube: { controls: false, iv_load_policy: 3, modestbranding: 1, playsinline: true, rel: 0, showinfo: 0, widget_referrer: false },
	volume: 1
};